module.exports = __webpack_public_path__ + "static/media/Telove_mleko_s_CBD_retina.3c19292c.jpg";